<div style = "height: 370px; overflow-y:scroll; direction: rtl; text-align: left; margin-bottom: 0px;">
    <app-comment-item></app-comment-item>   
    
    <!-- <div *ngIf = "comments.length === 0" style="max-width: 737px;height:350px;text-align: center; font-size: 22px; background-color: #D8D8D8;border: 5px solid rgb(230,230,230);padding-top: 70px;padding-bottom: 70px;color:#292F45;border-bottom-left-radius: 25px;border-bottom-right-radius: 25px;margin: 0 auto;">
            <p style="padding: 20px;">No reviews yet, other than from us</p> 
        </div>
    <app-comment-item *ngFor = "let comment of comments" [comment] = "comment"></app-comment-item> -->
</div>